// Mirrors: App\Enums\ChestTypes (core)
export const ChestType = Object.freeze({
    CURRENCY: 1,
    CHARACTER: 2,
    ABILITY: 3,
    COSMETIC: 4,
    BUNDLE: 5,
});
